import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FeedItem } from "./FeedItem";
import Spinner from "../Spinner";
import { Virtuoso } from "react-virtuoso";
import { NewUsersSection } from "../../views/Home/NewUsers";
import VideosList from "../VideosList/VideosList";
import CommunitiesList from "../CommunitiesList/CommunitiesList";
import CanadaNow from "../CanadaNow/CanadaNow";
import { SectionSeparator } from "../Separator";
import TrendingPosts from "../TrendingPosts/TrendingPosts";
import { getTrendingPosts } from "../../redux/actions/postActions";

const POST_FEED_LIMIT = 20;

function Feed({
  postsSelector,
  fetchAction,
  fetchActionProps,
  showNewUsers,
  children,
}) {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const posts = useSelector(postsSelector);
  const postState = useSelector((state) => state.post);
  const { modifiedPost, newPost, newRepost } = postState;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchAction(fetchActionProps ? { ...fetchActionProps, page } : page),
    );
  }, [
    dispatch,
    page,
    fetchActionProps,
    fetchAction,
    modifiedPost,
    newPost,
    newRepost,
  ]);

  return (
    <>
      {/* {children} */}
      {posts ? (
        posts.length > 0 ? (
          <Virtuoso
            style={{ height: "100%", background: "#f8f9fa" }}
            defaultItemHeight={500}
            data={posts}
            // ADD THIS:
            components={{
              Header: () => <>{children}</>,
            }}
            endReached={() => {
              if (page * POST_FEED_LIMIT > posts.length) return;
              setPage(page + 1);
            }}
            itemContent={(index, post) => {
              const rowKey = post._id || post.id || index;

              if (showNewUsers && index === 0) {
                return (
                  <div key={rowKey}>
                    <NewUsersSection />
                    <SectionSeparator />
                    <FeedItem post={post} index={index} />
                    <SectionSeparator />
                  </div>
                );
              } else if (showNewUsers && index === 1) {
                return (
                  <div key={rowKey}>
                    <FeedItem post={post} index={index} />
                    <SectionSeparator />
                    <TrendingPosts />
                    <VideosList />
                  </div>
                );
              } else if (showNewUsers && index === 2) {
                return (
                  <div key={rowKey}>
                    <FeedItem post={post} index={index} />
                    <SectionSeparator />
                    <CommunitiesList />
                    <SectionSeparator />
                    <CanadaNow />
                    <SectionSeparator />
                  </div>
                );
              }
              return (
                <div key={rowKey}>
                  <FeedItem post={post} index={index} />

                  {index !== posts.length - 1 && <SectionSeparator />}
                </div>
              );
            }}
            increaseViewportBy={{ top: 15000, bottom: 2000 }}
          />
        ) : (
          <div className="display-flex flex-direction-c align-items-c">
            <div className="view-wrapper">
              {children}
              <p>{t("noPostsText")}</p>
            </div>
          </div>
        )
      ) : (
        <Spinner />
      )}
    </>
  );
}

export default Feed;
